<template>
    <div class="container">
        Hold tight, logging you out...
    </div>
</template>

<script>
    export default {
        name: "UserLogout",
        mounted() {
            axios.post("/logout").then(response => {
                localStorage.removeItem("isLoggedIn");
                this.$store.dispatch("logoutUser");
                window.location.href = "/";
            });
        }
    };
</script>
